module.exports = __webpack_public_path__ + "img/digithia-favicon.10cf453b.png";